export const NUMERIC_SET = " 0123456789";
export const TIME_SET = " 0123456789:";
export const ALPHANUMERIC_SET = " ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789:-.>";
export const CHAR_SET = ALPHANUMERIC_SET;
